
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const ImageSpecimen = makeShortcode("ImageSpecimen");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<blockquote>
<p parentName="blockquote">{`Documentation for Visualize`}</p>
</blockquote>
<ImageSpecimen src="./static/docs/hero.png" plain mdxType="ImageSpecimen" />
<h4>{`Authors`}</h4>
<p>{`This project and documentation was created by `}<a parentName="p" {...{
        "href": "https://www.interactivethings.com"
      }}>{`Interactive Things`}</a>{`:`}</p>
<ul>
<li parentName="ul">{`Jeremy Stucki`}</li>
<li parentName="ul">{`Solange Vogt`}</li>
<li parentName="ul">{`Jan Wächter`}</li>
<li parentName="ul">{`Luc Guillemot`}</li>
<li parentName="ul">{`Annina Walker`}</li>
<li parentName="ul">{`Kerstin Faye`}</li>
<li parentName="ul">{`Bartosz Prusinowski`}</li>
<li parentName="ul">{`Patrick Browne`}</li>
<li parentName="ul">{`Noah Onyejese`}</li>
<li parentName="ul">{`Mark Kunzmann`}</li>
</ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;